import { LedgerStore, type KeyValueStore } from '@ordo-mentis/ledger-store';

// Browser-backed ledger singleton. The store is the typed @ordo-mentis/ledger-store
// over window.localStorage; on first use it migrates the legacy ordoMentis_* keys
// forward (see the package). All swallow storage errors (private mode, quota).
const browserStore: KeyValueStore = {
  getItem: (k) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  },
  setItem: (k, v) => {
    try {
      localStorage.setItem(k, v);
    } catch {
      /* ignore */
    }
  },
  removeItem: (k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  },
};

export const ledger = new LedgerStore(browserStore);
export type { SandboxScenario, PaperTrade, Forecast, AssetClass } from '@ordo-mentis/ledger-store';
